module.exports = __webpack_public_path__ + "static/media/howtoplay.00f966b9.png";